import React, { createContext, useContext } from 'react'
import { getTranslation } from '../translations'

const LanguageContext = createContext({ language: 'english', t: getTranslation('english') })

export const LanguageProvider = ({ language = 'english', children }) => {
  const t = getTranslation(language)
  
  return (
    <LanguageContext.Provider value={{ language, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}

